import { render, staticRenderFns } from "./popup-import-guige.vue?vue&type=template&id=50b7791a&scoped=true"
import script from "./popup-import-guige.vue?vue&type=script&lang=js"
export * from "./popup-import-guige.vue?vue&type=script&lang=js"
import style0 from "./popup-import-guige.vue?vue&type=style&index=0&id=50b7791a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b7791a",
  null
  
)

export default component.exports